import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{

  },
  menu: {
    borderRadius: '0px 0px 12px 12px',
    background: 'linear-gradient(113deg, rgba(255, 255, 255, 0.66) 0%, rgba(255, 255, 255, 0.64) 110.84%)',
    marginBottom:'29px',
    borderLeft: '2px solid #FFF',
    borderRight: '2px solid #FFF',
    borderBottom: '2px solid #FFF',
  }
}));

export default useStyles;
